import { render } from "./attribute-pop.vue?vue&type=template&id=8f0335e8&scoped=true"
import script from "./attribute-pop.vue?vue&type=script&lang=js"
export * from "./attribute-pop.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-8f0335e8"

export default script